import { memo } from 'react';
import { useTranslation } from 'react-i18next';
// Import Components
import { Button, Tooltip } from '@geneui/components';
// Import Constants
import { l } from 'constants/common';
// Import SCSS
import styles from './notificationPanel.module.scss';

const NotificationHeader = ({ onMarkAllRead, isVisibleButton }) => {
    const { t } = useTranslation();
    return (
        <div className={styles.header}>
            <h4>{t(l.Notifications)}</h4>
            {isVisibleButton && (
                <Tooltip text={t(l.MarkAllAsRead)}>
                    <Button
                        appearance="minimal"
                        color="primary"
                        icon="bc-icon-mail-templates-48"
                        onClick={onMarkAllRead}
                    />
                </Tooltip>
            )}
        </div>
    );
};

export default memo(NotificationHeader);
